import { SuggestedSearchResponse } from "@api-types/suggested-search";
import { SuggestedSearchListItem } from "@data-types/suggested-search";
import { SuggestedSearchListItemType } from "@data-types/suggested-search/SuggestedSearchListItemType";

export class SearchUtility {
	static transformSearchList(
		response: SuggestedSearchResponse
	): SuggestedSearchListItem[] {
		const data = response;
		const items = data.items;
		const lookups = data.lookup;

		const results = new Array(items.length);
		const tournaments = new Map();
		/* const tournamentEventsMap = new Map(); */

		for (let i = 0; i < items.length; i++) {
			const item = items[i];

			const category = lookups.categories[item.categoryId] || null;
			const sport = lookups.sports[item.sportId] || null;
			const teamOne = lookups.teams[item.teamOneId] || null;
			const teamTwo = lookups.teams[item.teamTwoId] || null;
			const tournamentId = item.tournamentId;
			const eventId = item.eventId;
			const tournament = lookups.tournaments[tournamentId] || null;

			const teamOneSearch = teamOne?.name
				? this.splitName(teamOne.name)
				: [];
			const teamTwoSearch = teamTwo?.name
				? this.splitName(teamTwo.name)
				: [];
			const tournamentSearch = tournament?.name
				? this.splitName(tournament.name)
				: [];

			/* if (!tournamentEventsMap.has(tournamentId)) {
				tournamentEventsMap.set(tournamentId, new Set());
			}
			tournamentEventsMap.get(tournamentId).add(eventId); */

			const teamsSearch = Array.from(
				new Set([...teamOneSearch, ...teamTwoSearch])
			);

			results[i] = {
				type: SuggestedSearchListItemType.Event,
				eventId,
				category,
				sport,
				teamOne,
				teamTwo,
				tournament: tournament
					? {
							/* tournamentId: tournament.tournamentId, */
							name: tournament.name,
							abrv: tournament.abrv,
							showCountryFlag: tournament.showCountryFlag,
						}
					: null,
				search1: teamsSearch,
				search2: tournamentSearch,
				key: `${tournamentId}-${eventId}`,
			};

			if (!tournaments.has(tournamentId)) {
				tournaments.set(tournamentId, {
					type: SuggestedSearchListItemType.Tournament,
					tournamentId,
					details: tournament,
					category,
					sport,
					events: new Set([eventId]),
					search1: tournamentSearch,
					search2: new Set([...teamsSearch]),
					key: `${tournamentId}`,
				});
			} else {
				const existingTournament = tournaments.get(tournamentId);
				existingTournament.events.add(eventId);
				teamsSearch.forEach((name) =>
					existingTournament.search2.add(name)
				);
			}
		}

		const tournamentResults = Array.from(tournaments.values()).map((t) => ({
			...t,
			search2: Array.from(t.search2),
			events: Array.from(t.events),
		}));

		const mergedResults = results.concat(tournamentResults);

		return mergedResults;
	}

	static splitName(name: string | any[], minWordLength = 3) {
		let words = [];
		let currentWord = "";

		for (let i = 0, len = name.length; i < len; i++) {
			const char = name[i];

			if (char === "-" || char === " ") {
				if (currentWord.length >= minWordLength)
					words.push(currentWord.toLowerCase());
				currentWord = "";
			} else {
				currentWord += char;
			}
		}

		if (currentWord.length >= minWordLength) {
			words.push(currentWord.toLowerCase());
		}
		return words;
	}

	static searchItems(
		items: SuggestedSearchListItem[],
		query: string,
		maxResults: number
	) {
		if (!query || query.length < maxResults) return [];

		const results = [];

		for (const item of items) {
			let priority = -1;

			if (item.search1.some((word: string) => word.startsWith(query))) {
				priority =
					item.type === SuggestedSearchListItemType.Event ? 1 : 2;
			} else if (
				item.search2.some((word: string) => word.startsWith(query))
			) {
				priority =
					item.type === SuggestedSearchListItemType.Event ? 3 : 4;
			}

			if (priority !== -1) {
				results.push({ item, priority });
			}
		}

		const searchResult = results
			.sort((a, b) => a.priority - b.priority)
			.map((entry) => entry.item);

		return searchResult;
	}
}
